<nb-card
  [ngClass]="{
    dialogSize: styleDialog === undefined
  }"
  [style]="styleDialog"
  >
  <nb-card-body>
    <ng-container
      [ngTemplateOutlet]="dialogTemplate"
      [ngTemplateOutletContext]="{ $implicit: data }"
    ></ng-container>
  </nb-card-body>

  @if (!emptyToolbar) {
    <app-standalone-actions-toolbar
      class="minHeight"
      [leftButton]="leftButton"
      [rightButton]="rightButton"
    ></app-standalone-actions-toolbar>
  } @else {
    <app-standalone-actions-toolbar
      class="minHeight"
    ></app-standalone-actions-toolbar>
  }
</nb-card>
